import PropTypes from "prop-types";
import CustomSpan from "../components/CustomSpan";
import {formatDate} from "../utils/datetime-utils";
import {useNavigate} from 'react-router-dom';

function Machine(props) {
  const {item, updateSettings, CustomStyles} = props;
  const lastInspectionDate = item.last_inspection_date ? formatDate(new Date(item.last_inspection_date)) : '-';
  const nextScreen = item.link ? item.link : '#';
  const navigate = useNavigate();


  const handleRedirect = async () => {
    await updateSettings();
    return navigate(nextScreen)
  };

  return (
    <div onClick={() => handleRedirect()} className="cursor-pointer">
      <div
        className={`${CustomStyles} relative bg-[#F9FAFB] rounded-lg border border-[#D0D5DD] xl:w-[240px] 2xl:w-[260px] lg:w-[220px] w-[180px] xl:p-[12px] p-[8px]`}>
        <h4 className="text-[#344054] w-full font-bold 2xl:text-[18px] xl:text-[17px] lg:text-[16px] text-[15px] leading-7 truncate"
            title={item.name}>{item.name}</h4>
        <CustomSpan
          text={"直近点検日: " + lastInspectionDate}
          className="text-[#667085] 2xl:text-base xl:text-[15px] text-[14px] mt-[4px] block whitespace-nowrap"
        ></CustomSpan>
      </div>
    </div>
  );
}

export default Machine;

Machine.propTypes = {
  item: PropTypes.object.isRequired,
  CustomStyles: PropTypes.string,
  dataSearch: PropTypes.object
};

Machine.defaultProps = {
  CustomStyles: "",
};
